<template>
    <div id="vendorPaymentPreview">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> {{pageTitle}}</div>
                    <div class="btn-groups text-right">
                        <button v-if="flagAll != 'all' && status.toLowerCase() == 'pending'" type="button" class="btn btn-primary" v-on:click="changePaymentStatus('confirmed')" >
                            <i class="fp-save"> </i> Confirm
                        </button>
                        <button v-if="status.toLowerCase() == 'confirmed'" type="button" class="btn btn-secondary" v-on:click="print('print_payment_cheque')" >
                            <i class="fp-print"> </i> Print
                        </button>
                        <button type="button" class="btn btn-secondary" v-on:click="downloadPdf()" >
                            <i class="fp-download"> </i> Download
                        </button>
                        <button type="button" class="btn btn-secondary" v-on:click="backBtn()" >
                            <i class="fp-back"> </i> Back
                        </button>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content vendor-payment-preview">
                        <section class="bg-white">
                            <template v-if="flagAll == ''">
                                <div class="invoice-view-table" id="print_payment_cheque">
                                </div>
                            </template>
                            <template v-else>
                                <template v-if="viewArr && viewArr.length > 0">
                                    <template v-for="(view,vkey) in viewArr">
                                        <p v-if="vkey > 0" :key="vkey"> &nbsp;</p>
                                        <div :key="vkey" class="invoice-view-table" v-fp-html="view" id="print_payment_cheque">
                                        </div>
                                    </template>
                                </template>
                            </template>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';


import {commonMixins} from '../../mixins/commonMixins';


export default {
    name: "vendorPaymentPreview",
    
    mixins:[commonMixins],
    data: () => ({
        isPrintable: '',
        invoiceArr:[],
        loading:false,
        permissions:[],
        cantAccessPage:"",
        paymentId : 0,
        path:"",
        invoice_number:'',
        invoice_date:'',
        due_date:'',
        customer:'',
        terms:'',
        po_no:'',
        invoice_type:'',
        sub_total:'',
        tax_amount:'',
        total:'',
        invoiceItemsArr:[],
        cust_code:'',
        cust_name:'',
        p_data:'',
        originalContents:'',
        vendorPaymentIdArr:[],
        status:'',
        contentHtml:'',
        check_type:'ach',
        pageTitle:"Vendor Payment ACH Detail",
        paymentIdArr:[],
        flagAll:'',
        viewArr:[],
        fromUrl:''
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'view_vendor_payment') {
                    self.cantAccessPage = true;
                }
            });
            if(self.cantAccessPage == ''){
                self.cantAccessPage = false;
            }
        },
        // contentHtml: function(){
        //     var self = this;

        //     setTimeout(function(){
        //         $('#positionElement').css('position','relative');
        //         $('#positionElement1').css('position','relative');
        //     },1000);
        // }
    },
    mounted: function() {
        var self = this;
        // self.paymentId = this.$route.params.id;

        var webloc = window.location.href;

         var decodeStr = "";

        if ( this.$route.query.data != '' && this.$route.query.data != undefined ) {
            decodeStr = atob(this.$route.query.data)
        }

        var url = new URL(webloc+"?"+decodeStr);
        if (url.searchParams.get("flag") && url.searchParams.get("flag") == 'all'){
            self.flagAll = url.searchParams.get("flag");
            self.paymentIdArr = url.searchParams.get("payment_ids");
        }else{
            self.paymentId = url.searchParams.get("payment_id");
            self.status = url.searchParams.get("status");
            self.check_type = url.searchParams.get("type");
            self.fromUrl = url.searchParams.get("fromUrl");

        }

        if (self.check_type == "ach") {
            self.pageTitle = "Vendor Payment ACH Detail";
        }else{
            self.pageTitle = "Vendor Payment Check Detail";
        }

        self.getPermissions();
        self.loadCheckData();
        self.path = process.env.API +  "/images/logo.png";
    },
    metaInfo() {
        return {
            title: (this.check_type == "ach")? "Vendor Payment ACH Detail | " +process.env.COPYRIGHT_NAME : "Vendor Payment Check Detail | " +process.env.COPYRIGHT_NAME
        }
    },
    methods : {

        backBtn(){
            var self = this;
            var url = "/vendor-payment/list";
            if ( self.fromUrl != "" && self.fromUrl != null ) {
                url = self.fromUrl;
            }
            self.redirectPageUrl(url);
        },
        loadCheckData() {
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/payment-check/preview",
                type: "GET",
                data: {
                    payment_id:self.paymentId,
                    flag:self.flagAll,
                    paymentIdArr:self.paymentIdArr
                },
                crossDomain: true,
                dataType:'json',
                headers: this.ajxHeaders,
                // dataType: "html",
                success: function (data) {
                    self.loading = false ;
                    if (self.flagAll == ''){

                        setTimeout(function(){

                            $("#print_payment_cheque").html("");
                            setTimeout(function(){
                                $("#print_payment_cheque").html(data.content);
                            },200);
                        },500);
                        self.status = data.payment_status;
                        self.contentHtml = data.print;
                    }else{
                        self.viewArr = data.content;
                        self.contentHtml = data.print_content;
                    }


                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'payment-check-preview');
                }
            });
        },
        downloadPdf() {
            var self = this;
            self.loading = true ;
            $.ajax({
                url: process.env.ROOT_API + "/cheque/pdf",
                type: "POST",
                data: {
                    payment_id:self.paymentId,
                    flag:self.flagAll,
                    paymentIdArr:self.paymentIdArr
                },
                headers: this.ajxHeaders,
                dataType: 'json',
                success: function (data) {
                    self.loading = false ;
                    if (data.status == 'success'){
                        var link = document.createElement('a');
                        document.body.appendChild(link);
                        link.href = data.content;
                        link.download = '';
                        link.target = "_blank";
                        link.click();
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'payment-check-pdf');
                }
            });

        },
        // print() {
        //     var self = this;
        //     self.loading = true;
        //     var content = document.getElementById('print_payment_cheque').innerHTML;

        //     var a = window.open(content, '_blank');
        //     a.document.write(content);
        //     a.document.close();
        //     self.loading = false;
        //     a.print();
        //     a.close();
        // }

        print(el) {

            var self = this;

            // var printContents = document.getElementById(divName).innerHTML;
            // self.originalContents = document.body.innerHTML;

            // document.body.innerHTML = printContents;

            // window.print();

            // document.body.innerHTML = self.originalContents;
            // window.close();
            var message = '';
            if (self.status == 'Printed' || self.status == 'printed'){

                message = 'Check already printed';
            } else {
                message = 'Once You print the Check the Check number will not be used again';
            }

            if (self.flagAll == ''){
                if (window.confirm(message)){


                    if(self.status == 'confirmed') {
                      console.log("YES PRINT");
                      self.changePaymentStatus('printed');
                    }



                    var restorepage = $('body').html();
                    // var printcontent = $('#' + el).clone();
                    // var enteredtext = $('#text').val();
                    $('body').empty().html(self.contentHtml);
                    window.print();
                    $('body').html(restorepage);
                    // $('#text').html(enteredtext);
                    // if (self.status != 'confirmed' && self.status != 'Confirmed'){

                        // self.changePaymentStatus();

                    // }
                } else {
                  console.log("NO PRINT");
                }
            }else{
              console.log("YOO PRINT");
                    var restorepage = $('body').html();
                    // var printcontent = $('#' + el).clone();
                    // var enteredtext = $('#text').val();
                    $('body').empty().html(self.contentHtml);
                    window.print();
                    $('body').html(restorepage);
            }

        },
        changePaymentStatus : function(status){
            var self = this;

            self.vendorPaymentIdArr.push(self.paymentId);
            var fields = {
                arr:self.vendorPaymentIdArr,
                status:status,
            }
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/vendor-payment/change-status",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;

                    if (data.status == "success") {

                        self.status = 'confirmed';
                        if (status == 'confirmed') {
                            self.$swal('','Vendor Payment Confirmed Successfully.','success');
                        }else{
                            self.$swal('','Vendor Payment Status Updated Successfully.','success');
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    if (flag == "list") {
                        $("#confirmPaymentBtn").prop("disabled", false);
                        $("#deletePaymentBtn").prop("disabled", false);
                    }else if (flag == "reason") {
                        $("submitReasonBtn").prop("disabled",false);

                    }else{
                        $("#confirmStatusBtnPreview").prop("disabled", false);
                        $("#cancelStatusBtnPreview").prop("disabled", false);
                    }
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'payment-check-change-status');
                }
            });
        }
    }
}
</script>





// WEBPACK FOOTER //
// src/components/payment/VendorPaymentPreview.vue